import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-w-full tw-gap-[10px]" }
const _hoisted_3 = { class: "tw-flex tw-justify-between tw-items-center tw-w-full" }
const _hoisted_4 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
}
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "tw-text-[#878787] tw-font-[500]" }
const _hoisted_7 = { class: "tw-flex tw-justify-between tw-items-center tw-w-full" }
const _hoisted_8 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
}
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]" }
const _hoisted_11 = { class: "tw-text-[#878787] tw-font-[500]" }
const _hoisted_12 = { class: "tw-flex tw-justify-between tw-items-center tw-w-full" }
const _hoisted_13 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
}
const _hoisted_14 = ["id"]
const _hoisted_15 = {
  key: 0,
  class: "custom-global-skeleton-pulse tw-w-[72px] tw-h-[72px] tw-rounded-[50%]"
}

import { getComponentUiText } from "@/utils/utilities";
import RadialProgressBar from "../prospect/prospectQuestions/componentTypes/radialProgressBar.vue";
import { ComputedRef, PropType, computed } from "vue";
import { CHECKLISTSTATUS } from "@/utils/constants";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import { IChecklistRequested } from "@/interfaces/vendor";
import VendorAssessmentScoreChart from "./vendorAssessmentScoreChart.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorProgressCard',
  props: {
  detail: {
    type: Object as PropType<IChecklistRequested>,
    required: false,
    default: () => ({}),
  },
  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
  classStyleContent: {
    type: String,
    default: "",
  },
  classStyleIcon: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;



const checklistInforDetail: ComputedRef<any> = computed(() => {
  return props.detail;
});

const isShowRadial = computed(() => {
  return checklistInforDetail.value.statusId !== CHECKLISTSTATUS.DONE;
});

const isGreyOut: ComputedRef<any> = computed(() => {
  return props.detail?.isArchived;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: `vendor-progress-card-${__props.detail.checklistRequestedId}`,
    class: "tw-flex"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'tw-bg-[#FCFCFC] tw-max-h-[112px] tw-min-h-[112px] tw-h-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-l-md tw-border-solid tw-border-[#EFF0F1]',
        __props.classStyleContent,
      ])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(`${
              isGreyOut.value ? 'tw-text-[#878787]' : 'tw-text-[#211F58]'
            } tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title`)
          }, _toDisplayString(_unref(getComponentUiText)("app-component-assessment-title-progress-1")), 3),
          (__props.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                id: `vendor-progress-card-completion-${__props.detail.checklistRequestedId}`,
                class: "tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]"
              }, [
                _createTextVNode(_toDisplayString(__props.detail.completion.toFixed(0)) + "/" + _toDisplayString(__props.detail.completionMax.toFixed(0)) + " ", 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString((__props.detail.completionPcnt * 100).toFixed(0)) + "%", 1)
              ], 8, _hoisted_5))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass(`${
              isGreyOut.value ? 'tw-text-[#878787]' : 'tw-text-[#211F58]'
            } tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title`)
          }, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessments-question-type-2-icon-tooltip-score-1",
              )), 3),
          (__props.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                id: `vendor-progress-card-score-${__props.detail.checklistRequestedId}`,
                class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title"
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode(_toDisplayString(__props.detail?.score.toFixed(0)) + "/" + _toDisplayString(__props.detail?.scoreMax) + " ", 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString((__props.detail.scorePcnt * 100).toFixed(0)) + "%", 1)
                ])
              ], 8, _hoisted_9))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: _normalizeClass(`${
              isGreyOut.value ? 'tw-text-[#878787]' : 'tw-text-[#211F58]'
            } tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title`)
          }, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessments-checklists-assessment-details-card-label-1",
              )), 3),
          (__props.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13))
            : (__props.detail.dateAdded)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  id: `vendor-progress-card-dateAdded-${__props.detail.checklistRequestedId}`,
                  class: "tw-text-[#878787] tw-text-[13px] tw-font-[400]"
                }, _toDisplayString(_unref(convertUTCTimeToLocalTime)(__props.detail.dateAdded)) + " - " + _toDisplayString(new Intl.DateTimeFormat("vi-VN", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              }).format(new Date(__props.detail.dateAdded))), 9, _hoisted_14))
              : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass([
        'tw-flex tw-items-center tw-min-w-[70px] tw-justify-center sm:tw-p-[4px] 2xl:tw-p-[20px] tw-bg-[#FCFCFC] tw-max-h-[112px] tw-max-w-[112px] tw-rounded-r-md tw-border tw-border-solid tw-border-[#EFF0F1] tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)]',
        __props.classStyleIcon,
      ])
    }, [
      (__props.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15))
        : (_openBlock(), _createBlock(RadialProgressBar, {
            key: 1,
            id: `vendor-progress-card-radial-progress-${__props.detail.checklistRequestedId}`,
            class: "d-inline",
            "total-steps": 100,
            "completed-steps": __props.detail.completionPcnt * 100,
            "is-hide-progress": true,
            "outer-stroke-color": "#48A0FF",
            "inner-stroke-color": `${isGreyOut.value ? '#B7B7B7' : '#48A0FF'}`
          }, null, 8, ["id", "completed-steps", "inner-stroke-color"]))
    ], 2), [
      [_vShow, isShowRadial.value]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass([
        'tw-flex tw-items-center tw-justify-center tw-pt-[55px] tw-p-[20px] tw-bg-[#ffffff] tw-max-w-[112px] tw-max-h-[112px] tw-rounded-r-md tw-border tw-border-solid tw-border-[#EFF0F1] tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)]',
        __props.classStyleIcon,
      ])
    }, [
      _createVNode(VendorAssessmentScoreChart, {
        "current-score": Number(__props.detail.scorePcnt),
        "pcnt-score": Number(__props.detail.scorePcnt),
        "note-color": '#62BB47',
        "current-score-color": 
          Number(__props.detail.scorePcnt) === 0 ? '#F7553C' : '#01893D'
        ,
        "total-score-color": 
          Number(__props.detail.scorePcnt) === 0 ? '#FEE5E2' : '#D9EDE2'
        ,
        width: 150
      }, null, 8, ["current-score", "pcnt-score", "current-score-color", "total-score-color"])
    ], 2), [
      [_vShow, !isShowRadial.value]
    ])
  ], 8, _hoisted_1))
}
}

})